// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { navActivate } from '../actions/actions';
import Sidebar from 'grommet/components/Sidebar';
import Header from 'grommet/components/Header';
import Footer from 'grommet/components/Footer';
import Title from 'grommet/components/Title';
import Logo from './Logo';
import Menu from 'grommet/components/Menu';
import Button from 'grommet/components/Button';
import CloseIcon from 'grommet/components/icons/base/Close';
import Anchor from 'grommet/components/Anchor';
import { sessionLogout } from '../actions/session';
class NavSidebar extends Component {

  constructor() {
    super();
    this._onClose = this._onClose.bind(this);
    this.logout = this.logout.bind(this);
  }

  _onClose() {
    this.props.dispatch(navActivate(false));
  }

  logout(){
    // confirm('Are you sure want to logout ?')
     this.props.dispatch(sessionLogout());
  }

  render() {
      // console.log('hi im nave')
    const { nav: { items } } = this.props;
    var links = items.map((page) => {
      return (
        <Anchor key={page.label} path={page.path} label={page.label} />
      );
    });
    let imageStyle = {
      width: '35%',
      marginLeft: '30%',
    }
    return (
      <div>
        <Header size="large" justify="between" pad={{ horizontal: 'medium' }}>
          <Title a11yTitle="Close Menu">
            {/*<Logo colorIndex='light-1' />*/}
            <img src="/img/logowithtext.png" className="logo" alt="" />
          </Title>
          {/*<Button icon={<CloseIcon />} onClick={this._onClose} plain={true}
            a11yTitle="Close Menu" />*/}
        </Header>
        <Menu fill={true} primary={true}>
          {links}
        </Menu>
        <Footer pad={{ horizontal: 'medium', vertical: 'small' }}>
          <div style={{ position: 'absolute', bottom: '2%'}}>
           <Button label='Logout'
              className='lighter-font'
              onClick={this.logout}
              primary={true}
              secondary={false}
              accent={false} />
          </div>    
        </Footer>
     </div>
    );
  }

}

NavSidebar.propTypes = {
  nav: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      path: PropTypes.string,
      label: PropTypes.string
    }))
  }),
  onClose: PropTypes.func,
  productName: PropTypes.string,
  router: PropTypes.object
};

let select = (state) => ({
  // instanceName: state.settings.settings.name,
  nav: state.nav
});

export default connect(select)(NavSidebar);



// WEBPACK FOOTER //
// ./src/js/components/NavSidebar.js